import { BlogSection } from '@/types/blog';

export const goldenSnippet: BlogSection = {
  id: 'golden-snippet',
  title: '',
  content: `
<div data-speakable="definition" class="border-l-4 border-joerg-400 pl-6 py-10 my-10 max-w-2xl mx-auto">
  <p class="text-lg font-semibold text-joerg-800 mb-3">Was bremst Entscheidungen in komplexen Systemen?</p>
  <p class="text-joerg-700 italic leading-relaxed">Wir stützen uns auf die Polyvagal-Theorie von Stephen Porges, um das Nervensystem wieder in die Sicherheit zu führen. Zudem nutzen wir Erkenntnisse über Entscheidungsmüdigkeit (Baumeister et al.), um Prozesse zu verschlanken. Das Ziel ist eine evidenzbasierte Begleitung ohne Esoterik.</p>
</div>
  `
};
